var oldStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = () => {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/.federation/entry.ed88bedcc080b4bd4b505c26739c3a86.js */ "./node_modules/.federation/entry.ed88bedcc080b4bd4b505c26739c3a86.js");
	}
	return oldStartup();
};